module.exports = __webpack_public_path__ + "img/ic24Persondata.ff12165b.svg";